<div
  class="card__container"
  [class.card--interactive]="interactive"
  [attr.tabindex]="interactive ? 0 : null"
>
  <ng-content></ng-content>
</div>
